import { NAV_REQUIREMENT } from './types/nav-enums';
import type { NavRouteDefinition, NavVisibilityContext } from './types/nav-types';

function isLegacyDashboardsEnabled(): boolean {
  return import.meta.env.VITE_APP_STAGE !== 'prod2';
}

function isRequirementMet(
  requirement: NAV_REQUIREMENT,
  context: NavVisibilityContext
): boolean {
  switch (requirement) {
    case NAV_REQUIREMENT.SHOPIFY_DATA:
      return context.hasShopifyData;
    case NAV_REQUIREMENT.REALTIME_ENV:
      return import.meta.env.VITE_APP_REALTIME_DASHBOARD === 'TRUE';
    case NAV_REQUIREMENT.LEGACY_DASHBOARDS_ENV:
      return isLegacyDashboardsEnabled();
    case NAV_REQUIREMENT.BETA_FEATURE_ENV:
      return import.meta.env.VITE_APP_BETA_FEATURE === 'TRUE';
    case NAV_REQUIREMENT.CONTACT_ACQUISITION_ENV:
      return import.meta.env.VITE_APP_CONTACT_ACQUISITION_ENABLED === 'TRUE';
    case NAV_REQUIREMENT.CONTACT_ACQUISITION_FEATURE:
      return context.accountFeatureFlagNames.includes('contactAcquisition');
    default:
      return true;
  }
}

export function isNavRouteVisible(
  route: NavRouteDefinition,
  context: NavVisibilityContext
): boolean {
  const requirements = route.requirements ?? [];
  return requirements.every(requirement => isRequirementMet(requirement, context));
}

export function filterVisibleNavRoutes(
  routes: readonly NavRouteDefinition[],
  context: NavVisibilityContext
): NavRouteDefinition[] {
  return routes.filter(route => isNavRouteVisible(route, context));
}
